export const BRAND_ID = '410E1C07-1205-4EBB-9AFC-2E4BFE1FC192';

